<template>
  <AiChat :open="visible" title="增加出口" @on-close="cancel" :showAiChat="false">
    <div>
      <Form :label-width="100">
        <FormItem label="选择意图">
          <Select style="width: 250px" v-model="intentId">
            <Option
              v-for="item in intents"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="规则">
          <condition-item
            style="margin-bottom: 10px"
            v-for="(item, index) in conditions"
            :key="index"
            :value="item"
            @input="conditions.splice(index, 1, $event)"
            @delete="conditions.splice(index, 1)"
          />
          <Row style="width: 500px">
            <Col span="22" offset="1">
              <Button type="dashed" long @click="addCondition" icon="md-add">添加规则</Button>
            </Col>
          </Row>
        </FormItem>
        <form-item-can-break :formItemProps="{ label: '强制打断', prop: 'force_break' }" v-model="force_break"/>
        <form-item-var v-model="vars"/>
      </Form>
      <keyword-hint :keywords="keywords" :allowSelect="false"/>
      <div class="btn">
        <Button @click="handleEdit" :disabled="!intentId">修改意图</Button>
				<Button style="margin: 0 20px" color="#547ed1" @click="cancel">取消</Button>
				<Button type="primary" style="margin-right: 20px" color="#547ed1" @click="submitBranch">确定</Button>
			</div>
      <intent-modal
        v-if="intentModal"
        v-model="showIntentModal"
        :curIntent="curIntent" 
        @onCancel="curIntent = undefined"
        @onSubmit="editIntent"
      />
    </div>
  </AiChat>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ConditionItem from '../views/rules/components/ConditionItem.vue';
import FormItemCanBreak from './FormItemCanBreak.vue';
import KeywordHint from './KeywordHint.vue';
import FormItemVar from './FormItemVar.vue';
import AiChat from '../views/aiChat/index.vue'

export default {
  components: { KeywordHint, ConditionItem, FormItemVar, FormItemCanBreak, AiChat },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ignore: {
      type: Array,
      default: () => [],
    },
    curBranch: {
      type: Object,
    },
  },
  data() {
    return {
      intentId: '',
      conditions: [],
      vars: [],
      force_break: false,
      showIntentModal: false,
      curIntent: undefined,
      intentModal: false,
    }
  },
  watch: {
    curBranch(val) {
      if (!val) return;
      this.intentId = val.intent_id || '';      
      this.conditions = val.conditions || []
      this.vars = val.vars || []
      this.force_break = val.force_break || false
    }
  },
	computed: {
    ...mapState('intents', [
      "intents", // 知识库
    ]),
    keywords() {
      const intent = this.intents.find(item => item.id === this.intentId);
      return intent?.sentences || [];
    },
	},
  methods: {
    ...mapActions('intents', ['saveIntent']),
		openModal() {
      this.showIntentModal = true;
		},
		editIntent(intent) {
			this.saveIntent(intent)
		},
		handleEdit() {
      const intent = this.intents.find(item => item.id === this.intentId);
      const index = this.intents.findIndex(item => item.id === this.intentId);
			this.curIntent = { ...intent, index };
      this.openModal();
		},
    submitBranch() {
      if (!this.intentId) return;
      // 删除掉值空的数据
      const conditions = this.conditions.filter(item => item.op && item.value)
      this.$emit('addBranch', {
        intentId: this.intentId,
        conditions: conditions,
        vars: this.vars,
        force_break: this.force_break,
      });
      this.cancel();
    },
    cancel() {
      this.intentId = ''
      this.conditions = []
      this.vars = []
      this.force_break = false
      this.$emit('change', false)
    },
    addCondition() {
      this.conditions.push({ rule: '', op: '', value: '', force_break: false })
    },

    loadComponent() {
      this.intentModal = true;
      if (!this.$options.components.IntentModal) {
        this.$options.components.IntentModal = () => import('../views/intent/components/intentModal.vue');
      }
    }
  },
  mounted() {
    this.loadComponent();
  }
};
</script>

<style lang="scss" scoped>
.formgroup{
	padding: 10px 0;
}
.btn {
  padding: 10px 16px;
  text-align: right;
}
</style>
